import {inject, Injectable} from '@angular/core';
import {DefaultUrlSerializer, UrlTree} from '@angular/router';
import {REGION_QUERY_PARAM, RegionService} from './region.service';

/** App URLs always carry the active region so a new tab can initialize from the query string. */
@Injectable()
export class RegionUrlSerializer extends DefaultUrlSerializer {
  private readonly regionService = inject(RegionService);

  override serialize(tree: UrlTree): string {
    const region = this.regionService.regionCode();
    if (!region || tree.queryParams[REGION_QUERY_PARAM] === region) {
      return super.serialize(tree);
    }

    const withRegion = Object.assign(new UrlTree(), tree, {
      queryParams: {...tree.queryParams, [REGION_QUERY_PARAM]: region},
    });
    return super.serialize(withRegion);
  }
}
